import Crud from './crud'
var crud = new Crud('feevolume', 'phí khối');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        ChinaStoreID: 1,
        ReceivePlaceID: 1,
        VolumeFrom: 0,
        VolumeTo: 0,
        Amount: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};